import { render, staticRenderFns } from "./CardExpert.vue?vue&type=template&id=93d2cc16&scoped=true&"
import script from "./CardExpert.vue?vue&type=script&lang=js&"
export * from "./CardExpert.vue?vue&type=script&lang=js&"
import style0 from "./CardExpert.vue?vue&type=style&index=0&id=93d2cc16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93d2cc16",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCard,VImg})


/* hot reload */
if (module.hot) {
  var api = require("D:\\Trabalho\\Lupa Soluções em TI\\Clientes\\Leonardo Raton\\Site\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('93d2cc16')) {
      api.createRecord('93d2cc16', component.options)
    } else {
      api.reload('93d2cc16', component.options)
    }
    module.hot.accept("./CardExpert.vue?vue&type=template&id=93d2cc16&scoped=true&", function () {
      api.rerender('93d2cc16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/SelecaoAssinatura/components/cards/acessor/CardExpert.vue"
export default component.exports